import React, { useState } from 'react';
import { Icon, Button, Input } from '@iq/react-components';

const InlineEditor = ({
  value,
  onSave,
  uniqueItems = [],
  uniqueError = '',
  requiredError = '',
  initialEditMode = false,
}) => {
  const [isEditMode, setEditMode] = useState(initialEditMode);
  const [localValue, setLocalValue] = useState(value);
  const [error, setError] = useState(null);
  const handleOnSave = () => {
    const isSame = localValue.trim().toLowerCase() === value.toLowerCase();
    if (localValue.trim().length === 0) {
      setError(requiredError);
    } else if (!isSame && uniqueItems.includes(localValue.trim().toLowerCase())) {
      setError(uniqueError);
    } else {
      onSave(localValue.trim());
      setEditMode(false);
    }
  };

  const handleChange = (event) => {
    setLocalValue(event.target.value);
    setError(null);
  };

  return (
    <div
      data-testid="inline-editor"
      className="inline-editor-component"
    >
      <div className="row">
        {!isEditMode && <React.Fragment>{value}</React.Fragment>}
        {isEditMode && (
          <Input
            data-testid="input-element"
            type="text"
            value={localValue}
            onChange={handleChange}
            autoFocus
          />
        )}
        <span className="controls">
          <Button
            data-testid="edit-button"
            activity="secondary"
            slim
            onClick={() => setEditMode(!isEditMode)}
            icon={<Icon icon={isEditMode ? 'he-close' : 'he-edit'} />}
          />
          {isEditMode && (
            <Button
              data-testid="save-button"
              activity="primary"
              slim
              onClick={handleOnSave}
              icon={<Icon icon="he-check" />}
            />
          )}
        </span>
      </div>
      {isEditMode && error && (
        <div
          data-testid="error-message"
          className="error"
        >
          {error}
        </div>
      )}
    </div>
  );
};

export default InlineEditor;
